export const remoteDataMapper = {
    getState: () => ({
        onLoading: () => ({
            status: "loading",
        }),
        onError: (e) => ({
            status: "error",
            error: e,
        }),
        onData: (d, isRefetching) => ({
            status: "success",
            data: d,
            isRefetching,
        }),
    }),
    getData: () => ({
        onData: (d) => d,
        onError: () => undefined,
        onLoading: () => undefined,
    }),
    getInitialLoading: () => ({
        onData: () => false,
        onError: () => false,
        onLoading: () => true,
    }),
    getFetching: () => ({
        onData: (_data, isRefetching) => isRefetching,
        onError: () => false,
        onLoading: () => true,
    }),
    getRefreshing: () => ({
        onData: (_data, isRefetching) => isRefetching,
        onError: () => false,
        onLoading: () => false,
    }),
    getError: () => ({
        onData: () => null,
        onError: (e) => e,
        onLoading: () => null,
    }),
};
